import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import { Body1 } from '@xo-union/tk-ui-typography';
import UserStore from '~/glm/models/user-store';
import origin from '~/glm/utils/url';
import Icon from '@xo-union/tk-component-icons';
import AnalyticsStore from '~/glm/models/analytics-store';
import styles from './address-collection-url.scss';
import GdsUiState from '~/glm/models/gds/gds-ui-state';

@inject('userStore', 'analyticsStore', 'gdsUiState')
@observer
class AddressCollectionUrl extends Component {
  static propTypes = {
    userStore: PropTypes.instanceOf(UserStore).isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
    gdsUiState: PropTypes.instanceOf(GdsUiState),
  };

  state = { copyBtnLabel: 'Copy Link' };

  handleClick = () => {
    const { analyticsStore, gdsUiState } = this.props;
    analyticsStore.track('Address Collection Interaction', { action: 'copy' });
    this.setState({ copyBtnLabel: 'Link Copied' });
    this.textInput.select();
    document.execCommand('copy');
    this.textInput.blur();
    setTimeout(() => this.setState({ copyBtnLabel: 'Copy Link' }), 2000);
    gdsUiState.showSnackbar('Link copied! Send it to guests so they can add themselves to your guest list.', 5000);
  };

  render() {
    const { wedding } = this.props.userStore;
    const url = `${origin()}/ac/${wedding.vanityUrl || wedding.slug}`;
    const { copyBtnLabel } = this.state;

    return (
      <div className={styles.wrapper}>
        <Body1>
          <input
            className={styles.textInput}
            readOnly
            value={url}
            ref={r => {
              this.textInput = r;
            }}
          />
        </Body1>
        <span className={styles.url}>{url}</span>
        <span className={copyBtnLabel === 'Copy Link' ? styles.copyLink : styles.copied} onClick={this.handleClick}>
          <Icon
            size="md"
            name={copyBtnLabel === 'Copy Link' ? 'copy' : 'checkmark_circle'}
            className={styles.copyIcon}
          />
          &nbsp;{copyBtnLabel}
        </span>
      </div>
    );
  }
}

export default AddressCollectionUrl;
